var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLightPremium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2347_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.75 0H20.25C9.06623 0 0 9.06623 0 20.25V69.75C0 80.9338 9.06623 90 20.25 90H69.75C80.9338 90 90 80.9338 90 69.75V20.25C90 9.06623 80.9338 0 69.75 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2347_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.75 0H20.25C9.06623 0 0 9.06623 0 20.25V69.75C0 80.9338 9.06623 90 20.25 90H69.75C80.9338 90 90 80.9338 90 69.75V20.25C90 9.06623 80.9338 0 69.75 0Z",
    fill: "url(#paint0_linear_2347_64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75 0H20.25C9.06623 0 0 9.06623 0 20.25V69.75C0 80.9338 9.06623 90 20.25 90H69.75C80.9338 90 90 80.9338 90 69.75V20.25C90 9.06623 80.9338 0 69.75 0Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4684 20.7176C30.4684 16.4553 27.0131 13 22.7508 13C18.4884 13 15.0331 16.4553 15.0331 20.7176V31.2498C15.0331 44.6109 25.868 58.278 44.9986 58.278C63.1709 58.278 74.9641 44.5998 74.9641 31.2498V20.7176C74.9641 16.4553 71.509 13 67.2466 13C62.9842 13 59.5286 16.4553 59.5286 20.7176V31.2498C59.5286 36.0403 54.6803 43.8425 44.9986 43.8425C35.3167 43.8425 30.4684 36.0403 30.4684 31.2498V20.7176Z",
    fill: "#E5AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4684 20.7176C30.4684 16.4553 27.0131 13 22.7508 13C18.4884 13 15.0331 16.4553 15.0331 20.7176V31.2498C15.0331 44.6109 25.868 58.278 44.9986 58.278C63.1709 58.278 74.9641 44.5998 74.9641 31.2498V20.7176C74.9641 16.4553 71.509 13 67.2466 13C62.9842 13 59.5286 16.4553 59.5286 20.7176V31.2498C59.5286 36.0403 54.6803 43.8425 44.9986 43.8425C35.3167 43.8425 30.4684 36.0403 30.4684 31.2498V20.7176Z",
    fill: "url(#paint1_radial_2347_64)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0331 24.1294V31.2496C15.0331 44.6107 25.868 59.2774 44.9986 59.2774C63.1709 59.2774 74.9641 44.5996 74.9641 31.2496V24.1389C72.571 35.5935 61.6625 43.6944 45.4346 43.8369C45.2906 43.8405 45.1453 43.8422 44.9986 43.8422C44.8517 43.8422 44.7059 43.8405 44.5612 43.8369C28.4127 43.6931 17.4346 35.5882 15.0331 24.1294Z",
    fill: "url(#paint2_radial_2347_64)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2347_64",
    x1: 0,
    y1: 0,
    x2: 90,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F4F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2347_64",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9986 19.9998) rotate(-90.0001) scale(28.5 52.6527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A88411"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2347_64",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9986 50.9997) rotate(-90) scale(71.0001 71.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFD54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5AF00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightPremium);
export default __webpack_public_path__ + "static/media/logo-light-premium.bd894f9e8a72c773d4662713af9372a6.svg";
export { ForwardRef as ReactComponent };